import http from "./http";

/* =========================================
   ✅ ADD SECTION A RESULT (NEW FORMAT)
========================================= */
export const addASectionResult = async ({
  league_id,
  settlements,
}) => {
  const res = await http.post(
    "a-new-game-result",
    { league_id, settlements },
    { headers: { "Content-Type": "application/json" } }
  );

  return res.data;
};

/* =========================================
   ✅ GET ALL SECTION A RESULTS
========================================= */
export const getAllASectionResults = async () => {
  const res = await http.post(
    "get_result",
    {},
    { headers: { "Content-Type": "application/json" } }
  );

  return res.data;
};

/* =========================================
   ✅ GET SINGLE QUESTION RESULT DETAILS
========================================= */
export const getASectionResultDetails = async (question_id) => {
  const res = await http.get(
    `a-game-result-details?question_id=${question_id}`
  );

  return res.data;
};